import { IItem, instanceOfIItem } from "./IItem";

export interface IAlternative extends IItem {
  alternatedContents: IItem[];
}

export function instanceOfIAlternative(instance: any): instance is IAlternative {
  return instance
    && (instance.alternatedContents !== undefined)
    && instanceOfIItem(instance);
}
